import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const deleteLocalizationGroup = {
  name: "deleteLocalizationGroup" as const,
  input: z.object({
    teamId: zExt.objectId(),
    localizationGroupId: zExt.objectId(),
  }),
  output: z.object({ success: z.boolean() }),
};
